// ══════════════════════════════════════════════════════════════
// API Configuration — Lloyd Funding
// ══════════════════════════════════════════════════════════════
// After deploying API Gateway, set your URL here ONCE.
// Every page imports from this file — no more find-and-replace.
//
// Your URL will look like:
//   https://xxxxxxxxxx.execute-api.us-east-1.amazonaws.com
//
// Or if you set up a custom domain:
//   https://api.lloydfunding.com
// ══════════════════════════════════════════════════════════════

const API_BASE_URL = "https://kmw1lr82s3.execute-api.us-east-1.amazonaws.com";

export const API = {
  CONTACT_FORM: `${API_BASE_URL}/contact-form`,
  GET_UPLOAD_URL: `${API_BASE_URL}/get-upload-url`,
  SUBMIT_APPLICATION: `${API_BASE_URL}/submit-application`,
  UPLOAD_DOCUMENTS: `${API_BASE_URL}/upload-documents`,
};